<template>
  <a-drawer
    :title="title"
    :visible="open"
    :maskClosable="false"
    @ok="submitForm"
    @cancel="cancel"
    :confirmLoading="confirmLoading"
    width="600px"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- 分类标识数组 - 多选下拉 -->

      <!-- 经销商名称 -->
      <a-form-model-item label="经销商名称">
        <span>{{ tenantName || '--' }}</span>
      </a-form-model-item>
      <a-form-model-item label="分类标识" prop="ids">
        <a-select
          mode="multiple"
          v-model="form.ids"
          placeholder="请选择分类标识"
          :filter-option="filterOption"
          show-search
          allow-clear
          style="width: 100%"
        >
          <a-select-option v-for="category in categoryList" :key="category.id" :value="category.id">
            {{ category.categoryName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 备注 -->
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入备注" :rows="4" :maxLength="500" show-count />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { batchAddTenantCategory, getCategoryList } from '@/api/system/tenantCategory'
import { getTenant } from '@/api/system/tenant'

export default {
  name: 'TenantPointForm',
  data() {
    return {
      open: false,
      title: '',
      confirmLoading: false,
      submitLoading: false,
      categoryList: [], // 分类列表
      tenantName: '', // 经销商名称
      form: {
        ids: [],
        remark: '',
        tenantId: undefined,
      },
      rules: {
        ids: [
          { required: true, message: '请选择分类标识', trigger: 'change' },
          { type: 'array', min: 1, message: '至少选择一个分类标识', trigger: 'change' },
        ],
        tenantId: [{ required: true, message: '网点标识不能为空', trigger: 'blur' }],
      },
    }
  },
  methods: {
    // 初始化添加表单
    handleAdd(tenantId) {
      this.open = true
      this.title = '添加关联网点'
      this.form.tenantId = tenantId

      // 重置表单
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
        this.form.ids = []
        this.form.remark = ''
        this.form.tenantId = tenantId
      })

      // 获取经销商名称
      this.getTenantName(tenantId)
      // 获取分类列表
      this.getCategoryList()
    },

    // 初始化修改表单
    handleUpdate(tenantId, selectedIds) {
      this.open = true
      this.title = '修改关联网点'
      this.form.tenantId = tenantId
      this.form.ids = selectedIds || []

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })

      // 获取经销商名称
      this.getTenantName(tenantId)
      // 获取分类列表
      this.getCategoryList()
    },

    // 获取经销商名称
    getTenantName(tenantId) {
      if (!tenantId) {
        this.tenantName = ''
        return
      }
      getTenant(tenantId)
        .then((response) => {
          if (response.code === '20001' && response.data) {
            this.tenantName = response.data.name || ''
          } else {
            this.tenantName = ''
          }
        })
        .catch((error) => {
          console.error('获取经销商名称失败:', error)
          this.tenantName = ''
        })
    },

    // 获取分类列表
    getCategoryList() {
      getCategoryList()
        .then((response) => {
          console.log(response)
          this.categoryList = response.data.records || []
        })
        .catch((error) => {
          console.error('获取分类列表失败:', error)
          this.categoryList = []
        })
    },

    // 下拉框搜索过滤
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true
          this.submitLoading = true

          const formData = {
            ids: this.form.ids,
            remark: this.form.remark,
            tenantId: this.form.tenantId,
          }

          batchAddTenantCategory(formData)
            .then((response) => {
              this.$message.success('操作成功')
              this.open = false
              this.$emit('ok') // 触发父组件刷新
            })
            .catch((error) => {
              console.error('操作失败:', error)
              this.$message.error('操作失败')
            })
            .finally(() => {
              this.confirmLoading = false
              this.submitLoading = false
            })
        }
      })
    },

    // 取消操作
    cancel() {
      this.open = false
      this.tenantName = ''
      this.$refs.form.resetFields()
    },
  },
}
</script>

<style scoped>
.ant-form-item {
  margin-bottom: 16px;
}
</style>
